module.exports = __webpack_public_path__ + "static/img/hb_43-min.d1aa9b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hb_43-min.png
// module id = ogH6
// module chunks = 1